import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="scroll-mt-24 mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24 lg:px-10">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
          {t('categories.title')}
        </h2>
        <p className="mt-4 text-base text-foreground-600">{t('categories.subtitle')}</p>
      </div>

      <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4 xl:grid-cols-7">
        {categories.map((c) => (
          <a
            key={c.id}
            href={c.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-0.5 hover:border-primary-300 cursor-pointer"
          >
            <div className="relative h-32 w-full overflow-hidden md:h-36">
              <img
                src={c.image}
                alt={`USFans Spreadsheet ${t(`categories.${c.id}`)}`}
                title={`USFans Spreadsheet ${t(`categories.${c.id}`)}`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between px-3 py-3">
              <span className="truncate text-xs font-semibold text-foreground-800 md:text-sm whitespace-nowrap">
                {t(`categories.${c.id}`)}
              </span>
              <span className="flex h-4 w-4 flex-none items-center justify-center text-foreground-400 group-hover:text-primary-600">
                <i className="ri-arrow-right-up-line text-base leading-none"></i>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}